import React, { useReducer, useState } from "react";
import { useTranslation } from "react-i18next";
import { I18N_NS_LEAVE } from "../../../features/leave/constants";
import { reducer_timeline } from "../reducers/timeline.reducer";
import { useQuery } from "react-query";
import { _api_get_timeline } from "../../../features/leave/api";
import { debounce } from "../../../utils/global";
import { getISOWeeksAndDays } from "../functions";

const useLogicTimeline = ({ isOnManagerPage = false }) => {
    const { t } = useTranslation(I18N_NS_LEAVE);

    const [calendar, dispatch] = useReducer(
        reducer_timeline.reducer,
        reducer_timeline.initialCalendar
    );

    const [rowsData, setRowsData] = useState([]);
    const [configToast, setConfigToast] = useState({
        visible: false,
        level: "success",
        content: "",
    });

    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    const { data: timeline, isLoading: isLoadingTimeline } = useQuery(
        ["timeline::get", [calendar.month + 1, calendar.year, calendar.search]],
        () =>
            _api_get_timeline({
                ...calendar,
                role: isOnManagerPage ? "manager" : "hr",
            }),
        {
            refetchOnWindowFocus: false,
            onSuccess: (response) => {
                // format rowsData
                const departments = response.departments;
                const formated_rows = [];

                for (let i = 0; i < departments?.length; i++) {
                    const department = departments[i];
                    // insert empty elements
                    formated_rows.push({
                        rowsCounter: null,
                        collapsed: null,
                        department_id: department.id,
                        events: [],
                        users: null,
                    });
                    // insert the right data
                    formated_rows.push({
                        rowsCounter: department.users_count,
                        collapsed: false,
                        department_id: department.id,
                        events: department.users.map((user) => user.leaves),
                        users: department.users.map((user) => {
                            return {
                                user: {
                                    id: user.id,
                                    name: user.name,
                                    avatar: user.avatar,
                                },
                                leaves: user.leaves,
                            };
                        }),
                    });
                }
                setRowsData(formated_rows);
            },
        }
    );

    // * FUNCTIONS
    // * FUNCTIONS
    // * FUNCTIONS
    const onChangeSearchInput = debounce((value) => {
        return dispatch({
            type: reducer_timeline.REDUCER_ACTIONS.search_employee_or_teams,
            payload: value,
        });
    }, 400);

    const hideOrShowModalEmployeeSolde = ({ visible, user }) => {
        return dispatch({
            type: reducer_timeline.REDUCER_ACTIONS.show_dialog_employee,
            payload: {
                visible,
                user,
            },
        });
    };

    const collapseDepartment = (department_id) => {
        return setRowsData((old_state) => {
            const new_state = old_state?.map((row) => {
                return {
                    ...row,
                    collapsed:
                        department_id === row.department_id
                            ? !row.collapsed
                            : row.collapsed,
                };
            });
            return new_state;
        });
    };

    let {
        isoWeeksAndDays,
        last_day: column_length,
        weekends,
    } = getISOWeeksAndDays(calendar.year, calendar.month);

    return {
        t,
        reducer: {
            calendar,
            dispatch,
        },
        query: {
            timeline,
            isLoadingTimeline,
        },
        functions: {
            onChangeSearchInput,
            hideOrShowModalEmployeeSolde,
            collapseDepartment,
        },
        toast: {
            configToast,
            setConfigToast,
        },
        rowsData,
        isoWeeksAndDays,
        column_length,
        weekends,
    };
};

export default useLogicTimeline;
